<template>
    <div class="page">
      <div>
        <ion-grid fixed >
          <ion-row class="row-divider"></ion-row>
          <ion-row class="rectangle">
            <ion-col size="2" size-md="12" size-lg="2" size-xs="12"></ion-col>
            <ion-col size="7" size-md="12" size-lg="7" size-xs="12">
              <canvas id="myChart1" class="my-chart"></canvas>
              <p class="noAssociatedStations" v-if="!noStationAssociatedInd && !displayInd" style="text-align: center;">No Associated Stations</p>
            </ion-col>
            <ion-col size="3" size-md="12" size-lg="3" size-xs="12" v-if="displayInd">
              <div class="status-info">
                <ion-row>
                    <ion-col><h2>Charger Status</h2></ion-col>
                </ion-row>
                <ion-row>
                    <ion-col><p class="available"><strong>Available: </strong></p></ion-col>
                    <ion-col><p class="available"><strong>{{chargerStatusData.displayData.availableCount}}</strong></p></ion-col>
                </ion-row>
                <ion-row>
                    <ion-col><p class="unavailable"><strong>Unavailable: </strong></p></ion-col>
                    <ion-col><p class="unavailable"><strong>{{chargerStatusData.displayData.unavailableCount}}</strong></p></ion-col>
                </ion-row>
                <ion-row>
                    <ion-col><p class="charging"><strong>Charging: </strong></p></ion-col>
                    <ion-col><p class="charging"><strong>{{chargerStatusData.displayData.chargingCount}}</strong></p></ion-col>
                </ion-row>
                <ion-row>
                    <ion-col><p class="thirdparty"><strong>Faulted: </strong></p></ion-col>
                    <ion-col><p class="thirdparty"><strong>{{chargerStatusData.displayData.faultedCount}}</strong></p></ion-col>
                </ion-row>
                <ion-row>
                    <ion-col><p class="total"><strong>Total: </strong></p></ion-col>
                    <ion-col><p class="total"><strong>{{chargerStatusData.displayData.totalCount}}</strong></p></ion-col>
                </ion-row>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
      </div>
    </div>
  </template>
  <script>
  import { defineComponent, render } from "vue";
  import { refresh } from 'ionicons/icons';
  import Chart from "chart.js/auto";
  import { CorporateService } from "../../service/corporate/corporate.service";
  import { flash } from 'ionicons/icons';
  import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
  import { ToastUtils } from "../../util/toast-utils";
  import userData from "../../../public/assets/data/data.json";
  
  export default defineComponent ({
    name: 'chargerStatusDashboard',
    components: {
      IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    props: {
      chartData : {type: Object}
    },
    data() {
      return {
        refresh,
        chartTypes: [{'name' : 'Charger Status'},{"name" : "Admin Dashboard"}],
        chartName: "",
        branchId: "",
        chartTypeInd: true,
        doughnutChartInd: true,
        myChart1: null,
        chargerStatusData: "",
        displayInd: false,
        loaderTab: false,
        noStationAssociatedInd: true,
        displayLineChart1: false,
        displayLineChart2: false,
        displayLineChart3: false,
        displayLineChart4: false,
        displayChargerStatus: false,
        displayFenfeoAdminChart: false,
        chargerCurrentStatusChart: null,
        dailyUsageBarChart: null,
        greenHousGasData: null,
        customerVisitCountData: null,
        transactionCountData: null,
        revenueCountData: null,
        stationsList: [],
        fromJson: null
      }
    },
    async mounted() {
      this.fromJson = userData.stationInfo;
      this.displayChargerStatus = true;
      this.chargerStatusData = this.chartData;
      if(this.chargerCurrentStatusChart) {
        this.chargerCurrentStatusChart.destroy();
        this.chargerCurrentStatusChart = null;
      }
      this.chargerStatusChart(this.chartData)
    },
    methods: {
      chargerStatusChart(chargerStatusData) {
        let chartData = chargerStatusData;
        this.displayInd = true;
        try {
          var ctx = document.getElementById('myChart1');
          this.chargerCurrentStatusChart = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: chartData.chartLabel,
                datasets: [{
                    data: chartData.chartData,
                    backgroundColor: chartData.chartColor
                }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: true,
              plugins: {
                labels: {
                  render:()=>{},
                  precision: 0,
                  showZero: true,
                  fontSize: 16,
                  fontColor: '#fff',
                  fontStyle: 'normal',
                  textShadow: true,
                  shadowBlur: 10,
                  shadowOffsetX: 5,
                  shadowOffsetY: 5,
                  shadowColor: 'grey',
                  arc: false,
                  position: 'default',
                  overlap: true,
                  showActualPercentages: false,
                },
                  
              },
              onClick: (e) => {
                var label = e.chart.tooltip.dataPoints[0].label;
                for(let i = 0; i< this.fromJson.length; i++) {
                  if(label == "Available") {
                    if(this.fromJson[i].status.name == 'Available') {
                      this.stationsList.push(this.fromJson[i]);
                    }
                  }
                  if(label == "Charging") {
                    if(this.fromJson[i].status.name == 'Occupied') {
                      this.stationsList.push(this.fromJson[i]);
                    }
                  }
                }
                localStorage.setItem('stationList', JSON.stringify(this.stationsList));
                this.$router.push("carterStations")
                // if(label == 'Available') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.available) )
                //   localStorage.setItem('dataType', "Available")
                //   this.$router.push("chargerStatusList");
                // } else if(label == 'Unavailable') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.unavailable))
                //   localStorage.setItem('dataType', "Unavailable")
                //   this.$router.push("chargerStatusList");
                // } else if(label == 'Charging') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.charging))
                //   localStorage.setItem('dataType', "Charging")
                //   this.$router.push("chargerStatusList");
                // } else if(label == 'ThirdParty') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.thirdParty))
                //   localStorage.setItem('dataType', "ThirdParfty")
                //   this.$router.push("chargerStatusList");
                // }
              }
            }
          });
        } catch(er) {
          alert(er);
        }
      },
    }
  })
  
  </script>
  
  <style scoped>
  .available {
    color: #66bd39;
  }
  .unavailable {
    color: #bcbab6;
  }
  .charging {
    color: #5e97c6;
  }
  .thirdparty {
    color: #d5593c;
  }
  .total {
    color: rgb(159, 21, 223);
  }
  .status-info {
    padding: 15px;
    margin-top: 35px;
    margin-right: 35px;
    /* text-align: center; */
    border: 3px solid grey;
    border-radius: 10px;
    box-shadow: 3px 3px grey;
  }
  .noStations {
    margin-top: -140px;
    font-weight: bold;
  }
  .noStations1 {
    margin-top: -220px;
    font-weight: bold;
  }
  .noAssociatedStations {
      
    margin-top: -440px;
    font-weight: bold;
  }
  .l-c1, .l-c2, .l-c3, .l-c4 {
    border: 1px solid lightgrey;
    margin: 2px;
    background: #ebebeb;
  }
  .btn-refresh {
    text-align: center !important;
    margin-left: 40px;
      font-family: "Roboto";
      font-size: 1.5rem;
      letter-spacing: 0;
      color: #ffffff;
      height: 40px;
      --background: #e1899c 0% 0% no-repeat padding-box;
      --background-focused: #b4b2b2 !important;
      --background-hover: #b4b2b2 !important;
      --webkit-background-focused: #b4b2b2 !important;
      --webkit-background-hover: #b4b2b2 !important;
      border-radius: 3px;
      opacity: 1;
      /* bottom: 0; */
  
  }
  .barChart1 {
    height: 370px !important;
  }
  .chart-label {
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
    text-align: center;
  }
  .my-chart {
      width: 450px !important;
      height: 450px !important;
  }
  .rectangle-dump {
    
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    padding: 1px;
    opacity: 1;
  }
  .rectangle-dump1 {
    
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    padding: 1px;
    opacity: 1;
  }
  .display-value {
    text-align: left;
    padding: 0;
    margin: 0;
    font-weight: bold;
  }
  @media screen and (max-width: 360px) {
      .my-chart {
          width: 350px !important;
          height: 350px !important;
      }
      .status-info {
          padding: 15px;
          margin-top: 35px;
          margin-right: 3px;
          text-align: center;
      }
  }
  </style>